// Shared constants for admin forms and fields

export const FIELD_NAMES = {
  SUBMIT_BUTTON: "submit_button",
} as const

export const ACTION_TYPES = {
  UPDATE: "update",
  CREATE: "create",
} as const

export const DEFAULT_SELECT_VALUE = "0" as const

export const DEFAULT_NONE_OPTION = {
  value: DEFAULT_SELECT_VALUE,
  label: "None",
} as const

